import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import {Provider} from "react-redux";
import {Store} from "./Store/Store";
import {BrowserRouter as Router} from "react-router-dom";
import {ErrorProvider} from "./Context/ErrorContext";
import {AmountProvider} from "./Context/AmountContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <Provider store={Store}>
            <Router>
                <ErrorProvider>
                    <AmountProvider>
                        <App/>
                    </AmountProvider>
                </ErrorProvider>
            </Router>
        </Provider>
    </React.StrictMode>
);
